import axios from "axios";
import { useQuery } from "react-query";
import { getHeader } from "../utils/util";
import { API_ENDPOINT } from "../utils/constants";

const useGetStaffList = (type, page = 1, limit = 30, sq = "") => {
  return useQuery({
    queryKey: ["get-staff-list", type, page, limit, sq],
    queryFn: async () => {
      const response = await axios.get(
        `${API_ENDPOINT}admin/get-staff-list?type=${type}&pageNumber=${page}&limitNumber=${limit}&searchQ=${sq}`,
        getHeader()
      );
      return response.data;
    },

    retry: (failureCount, error) => {
      if (!error.response) return true; // Retry on network errors
      const status = error.response.status;
      return status !== 401 && status !== 404 && status !== 500; // No retries for 404/500
    },
  });
};

export default useGetStaffList;
